export default __webpack_public_path__ + "static/poster-70e053b67510c9d9dd6bfa7d845f5180.png";